module.exports = __webpack_public_path__ + "img/portada6.2b1d48b7.svg";